module.exports = __webpack_public_path__ + "img/2.c31468ec.png";